/**
 * Matching Band discount (non-Plus):
 * 1) Auto-applies discount code when cart has _upsell_source = matching_band
 * 2) Clears code when that line is removed
 * 3) Checkout goes through /discount/CODE so checkout total matches
 */
(function () {
  var SYNCING = false;
  var LAST_STATE = null;
  var CHECKOUT_GUARD = false;

  function config() {
    return window.MatchingBandDiscountConfig || {};
  }

  function enabled() {
    var c = config();
    var code = String(c.code || '').trim();
    return !!(c.enabled !== false && code && Number(c.percent) > 0);
  }

  function cartRoot() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function hasMatchingBandUpsell(cart) {
    return ((cart && cart.items) || []).some(function (item) {
      var props = item.properties || {};
      return String(props._upsell_source || '') === 'matching_band';
    });
  }

  function codeApplied(cart, code) {
    var target = String(code || '').toUpperCase();
    return ((cart && cart.discount_codes) || []).some(function (entry) {
      return String((entry && entry.code) || '').toUpperCase() === target && entry.applicable !== false;
    });
  }

  function withTimeout(promise, ms) {
    return Promise.race([
      promise,
      new Promise(function (resolve) {
        setTimeout(function () {
          resolve(null);
        }, ms || 2500);
      }),
    ]);
  }

  function fetchCart() {
    return withTimeout(
      fetch(cartRoot() + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      }).then(function (r) {
        if (!r.ok) throw new Error('cart fetch failed');
        return r.json();
      }),
      2500
    );
  }

  function updateDiscount(code) {
    return withTimeout(
      fetch(cartRoot() + '/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ discount: code || '' }),
      }).then(function (res) {
        return res.json();
      }),
      2500
    );
  }

  function applyDiscountUrl(code) {
    return withTimeout(
      fetch('/discount/' + encodeURIComponent(code), {
        credentials: 'same-origin',
        redirect: 'manual',
      }),
      2000
    );
  }

  function getSectionIds() {
    var ids = ['cart-icon-bubble'];
    if (document.querySelector('cart-drawer')) ids.unshift('cart-drawer');
    if (document.getElementById('main-cart-items')) ids.push('main-cart-items');
    if (document.getElementById('main-cart-footer')) ids.push('main-cart-footer');
    return ids;
  }

  function refreshCartUI() {
    var sectionIds = getSectionIds();
    var cartDrawer = document.querySelector('cart-drawer');

    return fetch(cartRoot() + '?sections=' + sectionIds.join(','), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && sections['cart-drawer']) {
          var wasOpen = cartDrawer.classList.contains('active');
          cartDrawer.renderContents({ sections: sections });
          if (!wasOpen) {
            cartDrawer.classList.remove('active');
            document.body.classList.remove('overflow-hidden');
          }
        }

        // Cart page sections
        ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble'].forEach(function (id) {
          if (!sections[id]) return;
          var doc = new DOMParser().parseFromString(sections[id], 'text/html');
          if (id === 'main-cart-items') {
            var target = document.querySelector('#main-cart-items .js-contents') || document.querySelector('cart-items');
            var source = doc.querySelector('#main-cart-items .js-contents') || doc.querySelector('cart-items');
            if (target && source) target.innerHTML = source.innerHTML;
          } else if (id === 'main-cart-footer') {
            var ft = document.querySelector('#main-cart-footer .js-contents');
            var fs = doc.querySelector('#main-cart-footer .js-contents');
            if (ft && fs) ft.innerHTML = fs.innerHTML;
          } else if (id === 'cart-icon-bubble') {
            var bubble = document.getElementById('cart-icon-bubble');
            var src = doc.getElementById('shopify-section-cart-icon-bubble') || doc.querySelector('.shopify-section');
            if (bubble && src) {
              var inner = src.querySelector('#cart-icon-bubble') || src;
              bubble.innerHTML = inner.innerHTML;
            }
          }
        });
      })
      .catch(function () {});
  }

  function sync(options) {
    if (!enabled() || SYNCING) return Promise.resolve(null);
    var opts = options || {};
    var code = String(config().code || '').trim();
    if (!code) return Promise.resolve(null);

    SYNCING = true;
    return fetchCart()
      .then(function (cart) {
        if (!cart) return null;
        var need = hasMatchingBandUpsell(cart);
        var applied = codeApplied(cart, code);
        var next = need ? 'on' : 'off';

        if (LAST_STATE === next && applied === need && !opts.force) {
          return cart;
        }

        if (need && !applied) {
          return updateDiscount(code)
            .then(function (updated) {
              if (updated && codeApplied(updated, code)) return updated;
              return applyDiscountUrl(code).then(function () {
                return fetchCart();
              });
            })
            .then(function (updated) {
              LAST_STATE = 'on';
              if (!opts.silent) {
                return refreshCartUI().then(function () {
                  return updated;
                });
              }
              return updated;
            });
        }

        if (!need && applied) {
          return updateDiscount('').then(function (updated) {
            LAST_STATE = 'off';
            if (!opts.silent) {
              return refreshCartUI().then(function () {
                return updated;
              });
            }
            return updated;
          });
        }

        LAST_STATE = next;
        return cart;
      })
      .catch(function (err) {
        console.warn('[MatchingBandDiscount]', err);
        return null;
      })
      .finally(function () {
        SYNCING = false;
      });
  }

  function checkoutUrlWithDiscount() {
    var code = String(config().code || '').trim();
    if (!code) return '/checkout';
    return '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  }

  function ensureBeforeCheckout(event) {
    if (!enabled() || CHECKOUT_GUARD) return;
    var target = event.target;
    if (!target || !target.closest) return;

    var checkoutBtn = target.closest(
      'button[name="checkout"], input[name="checkout"], #checkout, #CartDrawer-Checkout, .cart__checkout-button, a[href*="/checkout"]'
    );
    if (!checkoutBtn) return;
    if (checkoutBtn.closest('.additional-checkout-buttons, .dynamic-checkout__content')) return;

    event.preventDefault();
    event.stopPropagation();
    CHECKOUT_GUARD = true;

    sync({ force: true, silent: true })
      .then(function (cart) {
        if (cart && hasMatchingBandUpsell(cart)) {
          window.location.href = checkoutUrlWithDiscount();
        } else {
          window.location.href = '/checkout';
        }
      })
      .catch(function () {
        window.location.href = checkoutUrlWithDiscount();
      })
      .finally(function () {
        setTimeout(function () {
          CHECKOUT_GUARD = false;
        }, 2500);
      });
  }

  window.MatchingBandDiscount = {
    sync: sync,
    refreshCartUI: refreshCartUI,
    hasMatchingBandUpsell: hasMatchingBandUpsell,
    fetchFreshSections: function () {
      return fetch(cartRoot() + '?sections=' + getSectionIds().join(','), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      }).then(function (r) {
        return r.json();
      });
    },
  };

  function boot() {
    if (!enabled()) return;
    sync({ force: true, silent: !/\/cart\/?$/.test(window.location.pathname) });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('cart:updated', function () {
    sync();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'matching-band-discount') return;
      setTimeout(function () {
        sync();
      }, 200);
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.target && event.target.closest && event.target.closest('cart-remove-button')) {
        setTimeout(function () {
          sync({ force: true });
        }, 500);
      }
    },
    true
  );

  document.addEventListener('click', ensureBeforeCheckout, true);
})();
